<template>
  <div>
    <div style="text-align: center; margin: 1em">
      <Card class="card">
        <template #header>
          <div style="text-align: center; margin: 1em;">
            RESULTADOS: <br /><br />
          </div>
          <div class="p-grid p-ai-end vertical-container" style=" margin: 1em">
            <div class="p-col-4 p-md-4 p-lg-4 p-sm-12" style="text-align: left">
              <p class="observacao1">
                * Alguns decisórios podem apresentar em seu conteúdo uma 
                numeração de processo diferente do listado no resultado. 
                Isso pode ocorrer devido à digitalização de processos 
                físicos que, ao tornarem-se eletrônicos, recebem nova 
                numeração. Entre em contato conosco em caso de dúvidas.
              </p>
            </div>
            <div class="p-col-4 p-md-4 p-lg-4 p-sm-12" style="text-align: right" />
            <div class="p-col-4 p-md-4 p-lg-4 p-sm-12" style="text-align: right">
              <Dropdown
                v-model="sortKey"
                :options="sortOptions"
                optionLabel="label"
                placeholder="Ordenar por ..."
                @change="onSortChange($event)"
              />
            </div>
          </div>
        </template>
        <template #content>
          <DataView
            :value="decisorios"
            :sortOrder="sortOrder"
            :sortField="sortField"
            paginatorPosition="both"
            :paginator="true"
            :rows="20"
            class="p-mb-1 p-mt-1"
            ref="dv"
          >
            <template #list="slotProps">
              <Panel style="width: 100%">
                <template #header>
                  <div class="p-grid fundo-card">
                    <div
                      class="p-col-12 p-md-6 p-lg-3"
                      style="display: flex; align-items: center"
                    >
                      <h5 style="text-align: justify; font-size: 14px">
                        <span class="label-text">Processo:</span>
                        {{ slotProps.data.numeroProcesso }}/{{
                          slotProps.data.anoProcesso
                        }}
                      </h5>
                    </div>
                    <div class="p-col-12 p-md-6 p-lg-3">
                      <h5 style="text-align: justify; font-size: 14px">
                        <span class="label-text">Natureza:</span>
                        {{ slotProps.data.natureza }}
                      </h5>
                    </div>
                    <div class="p-col-12 p-md-6 p-lg-3">
                      <h5
                        style="text-align: justify; font-size: 14px"
                        v-if="slotProps.data.orgaoJulgador"
                      >
                        <span class="label-text">Órgão:</span>
                        {{ slotProps.data.orgaoJulgador }}
                      </h5>
                    </div>
                  </div>
                  <div class="p-grid p-jc-center fundo-card">
                    <div class="p-col-12 p-md-6 p-lg-3">
                      <h5
                        style="text-align: justify; font-size: 14px"
                        v-if="slotProps.data.relatorVotoDecisao"
                      >
                        <span class="label-text">Relator do decisório:</span>
                        {{ slotProps.data.relatorVotoDecisao }}
                      </h5>
                    </div>
                    <div class="p-col-12 p-md-6 p-lg-3">
                      <h5
                        style="text-align: justify; font-size: 14px"
                        v-if="slotProps.data.numeroDecisorio"
                      >
                        <span class="label-text">Decisório:</span>
                        {{ slotProps.data.numeroDecisorio }}/{{
                          slotProps.data.anoDecisorio
                        }}
                      </h5>
                    </div>
                    <div class="p-col-12 p-md-6 p-lg-3">
                      <h5
                        style="text-align: justify; font-size: 14px"
                        v-if="slotProps.data.dataSessao"
                      >
                        <span class="label-text">Data Sessão:</span>
                        {{ formatarData(slotProps.data.dataSessao) }}
                      </h5>
                    </div>
                    <div class="p-col-12 p-md-6 p-lg-3">
                      <Button
                        icon="pi pi-download"
                        label="Visualizar"
                        @click="download(slotProps.data.caminhoArquivo)"
                        class="p-button-sm"
                      />
                    </div>
                  </div>
                </template>
                <p style="text-align: justify; font-size: 14px">
                  <span class="label-text">Objeto: </span>
                  {{ slotProps.data.objeto }}
                </p>
                <p style="text-align: justify; font-size: 14px">
                  <span class="label-text">Órgão: </span
                  >{{ slotProps.data.orgao }}
                </p>
                <p style="text-align: justify; font-size: 14px">
                  <span class="label-text">Partes: </span
                  >{{ slotProps.data.partes }}
                </p>
                <br />
                <div
                  v-html="slotProps.data.descricao"
                  style="text-align: justify"
                />
              </Panel>
            </template>
            <template #empty>
              <div
                v-if="decisorios.length == 0"
                style="text-align: center; margin: 1em"
              >
                <h6>
                  Não foi encontrado nenhum resultado para os critérios de busca
                  estabelecidos. Verifique se é possível ajustar os valores para
                  tornar a pesquisa menos restritiva e tente novamente.
                </h6>
              </div>
              <div v-else>
                <span>Realize a pesquisa</span>
              </div>
            </template>
          </DataView>
          <p class="observacao2">Esta busca está limitada aos primeiros 1000 (mil) registros e abrange decisórios a partir de 2016.</p>
          <Loading />
          <Toast>
          </Toast>
        </template>
      </Card>
    </div>
  </div>
</template>

<script>
import Loading from "../pages/Loading.vue";
//import Decisorios from "../service/Decisorios";

export default {
  data() {
    return {
      loading: false,
      sortKey: null,
      sortOrder: null,
      sortField: null,
      sortOptions: [
        { label: "Sessão mais recente", value: "!dataSessao" },
        { label: "Sessão mais antiga", value: "dataSessao" },
        { label: "Relator", value: "relatorVotoDecisao" },
        { label: "Natureza", value: "natureza" },
        { label: "Decisório",value: "numeroDecisorio"}
      ],
    };
  },

  methods: {
    formatarData(dataCrua) {
      var strData;

      strData = "" + dataCrua;

      return (
        strData.substring(6) +
        "/" +
        strData.substring(4, 6) +
        "/" +
        strData.substring(0, 4)
      );
    },

    download(url) {
      window.open(url);
    },

    onSortChange(event) {
      const value = event.value.value;
      const sortValue = event.value;

      if (value.indexOf("!") === 0) {
        this.sortOrder = -1;
        this.sortField = value.substring(1, value.length);
        this.sortKey = sortValue;
      } else {
        this.sortOrder = 1;
        this.sortField = value;
        this.sortKey = sortValue;
      }
    },
  },

  components: {
    Loading,
  },

  props: {
    decisorios: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style>
.matched-text {
  font-weight: bold;
  background-color: #f8cc46;
}

.label-text {
  color: #335e82;
  font-weight: bold;
}

.observacao1 {
  color: #335e82;
  font-style: italic;
}

.observacao2 {
  color: #7d89a3;
  font-style: italic;
}

.fundo-card {
  background-color: #f5f6f8;
  width: 100%;
}
</style>